import {useStaticQuery, graphql} from "gatsby"

const useArticleQuery = () => {
  const { allDatoCmsArticle, allDatoCmsCategory } = useStaticQuery(graphql`
    query Article {
      allDatoCmsCategory (
        sort: {title: ASC}
      ) {
        nodes {
          title
        }
      }
      allDatoCmsArticle(sort: {meta: {firstPublishedAt: DESC}}) {
        nodes {
          title
          slug
          jsonLd
          permalink
          seoMetaTags {
            tags
          }
          meta {
            firstPublishedAt(formatString: "DD MMMM YYYY")
          }
          thumbnail {
            ...InternalAssetProps
          }
          categories {
            title
          }
        }
      }
    }
`)

  return { allDatoCmsArticle, allDatoCmsCategory }
}

export default useArticleQuery